module.exports = __webpack_public_path__ + "img/SNGLS.03007ecf.svg";